namespace GeniuzPOS.Inventory {
    export interface IcStockSoldData extends Serenity.ListRequest {
        Header?: IcStockSoldRow;
        Details?: IcStockSoldDtRow[];
        SysDocNo?: string;
        Para?: Administration.CsParaRow;
        URLpic?: string;
        BizName?: string;
        BizAddressLine1?: string;
        BizAddressLine2?: string;
        BizAddressLine3?: string;
        TaxId?: string;
    }
}
